import GlobalErrorBoundary from './global-error-boundary'

export default GlobalErrorBoundary
